import Vue from 'vue'
import Vuex from 'vuex'
import axiosInstance from '@/axiosInstance'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLoading: false,
    isMobileMenuOpen: false,
    errorMessage: null,
    auth: {
      userId: null,
      sessionId: null
    },
    user: {
      id: null,
      firstName: null,
      surname: null,
      email: null,
      gender: null
    },
    shoe: {
      name: null,
      price: null,
      size: null,
      color: null
    },
    campaignData: {
      shoeEANCode: null,
      storeNumber: null
    },
    stores: []
  },
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload
    },
    setErrorMessage(state, payload) {
      state.errorMessage = payload
    },
    setMobileMenuOpen(state, payload) {
      state.isMobileMenuOpen = payload
    },
    setAuth(state, payload) {
      state.auth = payload
    },
    setUser(state, payload) {
      state.user = payload
    },
    setCampaignData(state, payload) {
      state.campaignData = { ...state.campaignData, ...payload }
    },
    setShoe(state, payload) {
      state.shoe = { ...state.shoe, ...payload }
    },
    setStores(state, payload) {
      state.stores = payload
    },
    logout(state) {
      state.user = {
        id: null,
        firstName: null,
        surname: null,
        email: null
      }
      state.auth = {
        userId: null,
        sessionId: null
      }
      state.shoe = {
        name: null,
        price: null,
        size: null,
        color: null
      }
      state.campaignData = {
        shoeEANCode: null,
        storeNumber: null
      }
    }
  },
  actions: {
    login({ commit, dispatch }, user) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axiosInstance
          .post('identity-signIn', user)
          .then(async res => {
            commit('setErrorMessage', null)

            // Maybe another check should be done here
            // i.e if(res.message === 'Login successful')
            if (res.status === 200) {
              localStorage.setItem('authUser', JSON.stringify(res.data))
              commit('setAuth', res.data)
              await dispatch('getUser')
              commit('setLoading', false)
            }
            resolve(res.data)
          })
          .catch(err => {
            commit('setLoading', false)
            commit(
              'setErrorMessage',
              err.response?.data?.message || 'An error occurred'
            )
            reject(err)
          })
      })
    },
    signup({ commit, dispatch }, user) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axiosInstance
          .post('identity-signUp', user)
          .then(async res => {
            commit('setErrorMessage', null)
            if (res.status === 200) {
              localStorage.setItem('authUser', JSON.stringify(res.data))
              commit('setAuth', res.data)
              await dispatch('getUser')
              commit('setLoading', false)
            }
            resolve(res.data)
          })
          .catch(err => {
            commit('setLoading', false)
            commit(
              'setErrorMessage',
              err.response?.data?.message || 'An error occurred'
            )
            reject(err)
          })
      })
    },
    getUser(context) {
      return new Promise((resolve, reject) => {
        const { userId, sessionId } = context.state.auth
        if (userId && sessionId) {
          axiosInstance
            .post('customer-read', { userId, sessionId })
            .then(res => {
              context.commit('setUser', res.data)
              localStorage.setItem('userData', JSON.stringify(res.data))
              resolve(res.data)
            })
            .catch(err => reject(err))
        }
      })
    },
    updateUser(
      { commit, dispatch, state },
      { firstName, surname, email, gender }
    ) {
      const { userId, sessionId } = state.auth
      return new Promise((resolve, reject) => {
        axiosInstance
          .post('customer-update', {
            firstName,
            surname,
            email,
            gender,
            userId,
            sessionId
          })
          .then(async res => {
            commit('setErrorMessage', null)
            dispatch('getUser')
            resolve(res.data)
          })
          .catch(err => {
            commit(
              'setErrorMessage',
              err.response?.data?.message || 'An error occurred'
            )
            reject(err)
          })
      })
    },
    getStores({ commit }, keyword) {
      return new Promise((resolve, reject) => {
        axiosInstance
          .get('stores-read', { params: { keyword } })
          .then(res => {
            commit('setStores', res.data)
            resolve(res.data)
          })
          .catch(err => reject(err))
      })
    },
    saveCustomerCareRegistration({ commit, state }) {
      commit('setLoading', true)
      const { userId, sessionId } = state.auth
      return new Promise((resolve, reject) => {
        axiosInstance
          .post('customerCareRegistration-save', {
            userId,
            sessionId,
            ...state.campaignData
          })
          .then(res => {
            commit('setLoading', false)
            console.log(res.data?.message)
            resolve(res.data)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    getRegisteredShoes({ state }) {
      const { userId, sessionId } = state.auth
      return new Promise((resolve, reject) => {
        axiosInstance
          .post('customerCareRegistration-read', { userId, sessionId })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => reject(err))
      })
    }
  },
  getters: {
    stores(state) {
      return state.stores.map(store => ({
        ...store,
        label: `${store.city} - ${store.name}`
      }))
    },
    userExists(state) {
      return !!(state.user.email && state.user.id)
    },
    isAuthorized(state) {
      return !!(state.auth.userId && state.auth.sessionId)
    }
  }
})

export default store
